// src/api/apiService.ts
import axiosInstance from './axiosInstance';

export const api = {
  get: async (url: string, config: { params?: object; [key: string]: any } = {}) => {
    try {
      const response = await axiosInstance.get(url, config);
      return response.data;
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
  post: async (url: string, data?: any, config = {}) => {
    try {
      const response = await axiosInstance.post(url, data ?? {}, config);
      return response.data;
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
  put: async (url: string, data: any, config = {}) => {
    try {
      const response = await axiosInstance.put(url, data, config);
      return response.data;
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
  patch: async (url: string, data: any, config = {}) => {
    try {
      const response = await axiosInstance.patch(url, data, config);
      return response.data;
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
  delete: async (url: string) => {
    try {
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

// normalizeApiError logs at the right level and returns the original error so
// callers can `throw normalizeApiError(error)` without double-throwing.
const normalizeApiError = (error: any) => {
  if (error?.isAxiosError) {
    if (error.response?.status === 401) {
      console.error('Unauthorized or session expired');
    } else if (error.response?.status === 404) {
      console.error('Resource not found');
    } else {
      console.error('API error:', error.message);
    }
  } else {
    console.error('Unexpected error:', error);
  }
  return error;
};
